import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58bd514a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "canvas-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-border-top" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-border-right" }, null, -1))
const _hoisted_4 = { class: "container-border-bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-border-left" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center mt-4" }, "Loading...", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  id: "canvas-wrapper",
  class: "relative"
}

import { computed, onMounted, ref } from 'vue';
import { Camera, Renderer, RendererPublicInterface, Scene } from 'troisjs';
import {
  animateBlimp,
  createPinDomElements,
  loadWorldModel,
  movePins,
  setWelcomeInstruction,
  addListeners,
  animateBall,
  loadCameraFromMemory,
  loadBlimp,
  buildControls,
  createSkybox,
  loadPortalScreen,
} from '@/utils';
import WelcomeInstruction from '@/components/WelcomeInstruction.vue';
import SidebarNav from '@/components/SidebarNav.vue';
import {
  Object3D,
  WebGLRenderer,
  PerspectiveCamera,
  Scene as Scene3,
} from 'three';
import { ActionTypes, useStore } from '@/state';
import { update as tweenUpdate } from '@tweenjs/tween.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { onBeforeRouteLeave } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const store = useStore();
const rendererRef = ref({} as RendererPublicInterface);
const sceneRef = ref({} as any);
const cameraRef = ref({} as any);
const year = computed(() => new Date().getFullYear());

let renderer: WebGLRenderer;
let scene: Scene3;
let camera: PerspectiveCamera;
let controls: OrbitControls;
let pins: Object3D[] = [];

onBeforeRouteLeave(() => {
  const wrapper = document.getElementById('canvas-wrapper')!;
  const clone = wrapper.cloneNode(true);
  wrapper.parentNode?.replaceChild(clone, wrapper);
});

onMounted(async () => {
  renderer = rendererRef.value?.renderer as WebGLRenderer;
  camera = cameraRef.value?.camera;
  scene = sceneRef.value?.scene;
  await loadWorldModel(scene);
  await createSkybox(scene);

  loadCameraFromMemory(camera, store);
  setWelcomeInstruction();
  pins = createPinDomElements(scene);
  controls = buildControls(renderer, camera);

  addListeners(controls, scene);
  await loadPortalScreen(scene, renderer, controls);
  await loadBlimp(scene, renderer, controls);

  setTimeout(() => {
    store.dispatch(ActionTypes.LOADED, true);
  }, 1500);

  rendererRef.value?.onBeforeRender(() => {
    controls.update();
    if (pins.length) {
      pins = movePins(camera, pins);
    }

    animateBlimp(scene);
    animateBall(scene);
    tweenUpdate();
    controls.update();
  });
});

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, "© RightClickable " + _toDisplayString(_unref(year)), 1)
    ]),
    _hoisted_5,
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_unref(store).state.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: require('@/assets/loading.gif'),
                alt: "MLC"
              }, null, 8, _hoisted_7),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(WelcomeInstruction)
      ]),
      _: 1
    }),
    (_unref(store).state.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_b_link, { to: "/" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "top-logo",
                src: require('@/assets/mlc-logo-yellow.png'),
                alt: "MLC"
              }, null, 8, _hoisted_9)
            ]),
            _: 1
          }),
          _createVNode(SidebarNav)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_unref(Renderer), {
        ref_key: "rendererRef",
        ref: rendererRef,
        resize: "",
        antialias: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Camera), {
            ref_key: "cameraRef",
            ref: cameraRef,
            near: 1,
            far: 7500
          }, null, 512),
          _createVNode(_unref(Scene), {
            ref_key: "sceneRef",
            ref: sceneRef
          }, null, 512)
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})